export default __webpack_public_path__ + "static/media/banner.1e49bdc1.jpg";